export default __webpack_public_path__ + "static/media/personal_booking_icon_motivation.68e04894.svg";